module.exports = __webpack_public_path__ + "img/collection-engagementRingsGold.a2d479f.jpg";